// extracted by mini-css-extract-plugin
module.exports = {"container":"_2P6Fjro9ShpSPC_Aip4_1Y","fieldsWrapper":"_2GWq90l546B7cF0NKyzCQL","requiredLabel":"fiaoBUPY_RZ-CKdR6Rq5e"};